import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowUpTrayIcon } from "@heroicons/react/24/outline";
import {
  Wallet,
  MessageCircle,
  FileText,
  X,
  Download,
  CheckCircleIcon,
  XCircleIcon,
  CalendarIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from "lucide-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import QrCode from "../assets/Bank_QR.webp";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { decrypt, encrypt } from "../utils/cryptoUtils";
import { payouthistry } from "../redux/InitiatepayoutSlice";
import { makeAuthenticatedRequest, Report } from "../utils/api";
import { AxiosError } from "../components/sessionexpiry";
import { Todaypayouts, LastfunloadHistry } from "../redux/DashbordSlice"; // Corrected import
import { ToastContainer, toast } from "react-toastify";
import "./Dashboard.css";

// Add these imports at the top of your wallet.js file
import {
  ClockIcon,
  ArrowDownIcon,
  ArrowsRightLeftIcon,
  LockClosedIcon,
  ArrowPathIcon,
  MinusCircleIcon,
  PauseIcon,
  QuestionMarkCircleIcon,
  ArrowUturnLeftIcon,
  ArrowDownTrayIcon,
  MagnifyingGlassIcon,
  DocumentArrowDownIcon,
  EllipsisHorizontalIcon,
} from "@heroicons/react/20/solid"; // or 24/solid depending on version

const Payouts = () => {
  const [showModal, setShowModal] = useState(false);

  //const [showReportModal, setShowModal] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false); // New state for report modal
  const [reportDate, setReportDate] = useState({
    startDate: new Date().toISOString().slice(0, 10),
    endDate: new Date().toISOString().slice(0, 10),
    status: "all",
  });
  const [status, setStatus] = useState("all");

  const [isGeneratingReport, setIsGeneratingReport] = useState(false);

  const [form, setForm] = useState({
    name: "",
    number: "",
    email: "",
    location: "",
    number2: "",
    ifsc: "",
    bank: "",
    amount: "",
    remarks: "",
    mode: "IMPS",
  });

  const allFilled = Object.values(form).every((v) => v.trim() !== "");

  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const limit = 10;
  const offset = (currentPage - 1) * limit;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const merchantData = useSelector((state) => state.Initiatepayout.payoutlist);
  //console.log("Merchant Data in Payouts:", merchantData);

  const users = JSON.parse(sessionStorage.getItem("users"));
  const user_id = users?.userdatils?.kycs_step ? users.userdatils.user_id : "0";
  //console.log("User ID in Payouts:", user_id);

  const [showFundModal, setShowFundModal] = useState(false);

  const [fundLoadForm, setFundLoadForm] = useState({
    depositBank: "",
    amount: "",
    payMode: "IMPS",
    payDate: new Date().toISOString().slice(0, 10),
    refNo: "",
    payslip: null,
    remark: "",
  });

  const fetchData = async () => {
    try {
      const whereClause = [
        {
          column: "mid",
          operator: "=",
          value: user_id,
        },
      ];

      if (status != "all") {
        whereClause.push({
          column: "response",
          operator: "=",
          value: status,
        });
      }

      const requestData = JSON.stringify({
        Dname: "payout",
        Tname: "payouts",
        Cname: [
          "mid",
          "payout_id",
          "payout_reference",
          "account_number",
          "account_ifsc",
          "bankname",
          "requesttype",
          "beneficiary_name",
          "beneficiary_email",
          "beneficiary_mobile",
          "beneficiary_location",
          "amount",
          "open_balance",
          "close_balance",
          "transaction_reference",
          "response",
          "status",
          "remarks",
          "credited_at",
          "reference_id",
          "CONVERT_TZ(created_at, @@session.time_zone, '+05:30') as created_at",
        ],
        Where: whereClause,
        Order: { id: "desc" },
        Search: searchTerm,
        Limit: `${limit}`,
        Offset: `${offset}`,
      });

      const encrypted = encrypt(requestData);
      //console.log("Encrypted Request Data:", encrypted);
      const data = await makeAuthenticatedRequest("POST", "/fetch", {
        encrypted,
      });
      //console.log("Encrypted Response Data:", data);
      const decryptdata = decrypt(data);
      //console.log("Decrypted Response Data:", decryptdata);
      const fixedString = decryptdata.replace(/\\"/g, '"');
      //console.log("Fixed String Response Data:", fixedString);
      const jsonArray = JSON.parse(fixedString);
      setTotalCount(jsonArray[0].TotalCount);
      dispatch(payouthistry(jsonArray));
      //console.log("Payout Merchant Data:", payouthistry);
    } catch (err) {
      setError(
        "Failed to fetch data: " + (err.response?.data?.message || err.message),
      );
    }
  };

  useEffect(() => {
    fetchData();
  }, [searchTerm, currentPage, status]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to first page when new search happens
  };

  const goToNextPage = () => setCurrentPage((prev) => prev + 1);
  const goToPrevPage = () =>
    setCurrentPage((prev) => (prev > 1 ? prev - 1 : 1));

  const totalPages = Math.ceil(totalCount / limit); // Calculate total pages

  const lastpayouts =
    merchantData && merchantData.length > 0 ? merchantData : [];

  /////// Balance //////////

  //const users = JSON.parse(sessionStorage.getItem("users"));
  //const user_id = users?.userdatils?.kycs_step ? users.userdatils.user_id : "0";

  const Todaypayoutsdetailes = useSelector((state) => state.Dashboard.today);
  const fund_history = useSelector((state) => state.Dashboard.fundloads);

  const [profileData, setProfileData] = useState({
    payout_balance: "0.00",
    virtual_account_no: "000000000000",
  });

  useEffect(() => {
    const payout_balance = async () => {
      try {
        const requestData = JSON.stringify({
          Dname: "payout",
          Tname: "merchants m",
          Cname: [
            "payout_balance",
            "virtual_account_no",
            "virtual_account_IFSC",
            "status",
          ],
          Where: [
            {
              column: "m.mid",
              operator: "=",
              value: user_id,
            },
          ],
          Limit: "10",
          Offset: "0",
        });

        const encrypted = encrypt(requestData);
        const data = await makeAuthenticatedRequest(
          "POST",
          "/fetch",
          { encrypted },
          navigate,
        );

        const decryptdata = decrypt(data);
        const fixedString = decryptdata.replace(/\\"/g, '"');
        const jsonArray = JSON.parse(fixedString);

        if (jsonArray.length > 1) {
          setProfileData({
            payout_balance: jsonArray[1].payout_balance || "0.00",
            virtual_account_no:
              jsonArray[1].virtual_account_no || "000000000000",
            virtual_account_IFSC: jsonArray[1].virtual_account_IFSC || "000000",
            status: jsonArray[1].status || "0",
          });
        }
      } catch (err) {
        setError(err.message);
        AxiosError(navigate, err);
      }
    };
    payout_balance();

    const todatpayout = async () => {
      const dateOnly = new Date().toISOString().slice(0, 10);

      try {
        const requestData = JSON.stringify({
          Dname: "payout",
          Tname: "payouts",
          Cname: [
            "response",
            "count(*) as count",
            "sum(amount) as amount",
            "ROUND(SUM(CASE WHEN response = 'success' THEN 1 ELSE 0 END) * 100.0 / COUNT(*), 2) as success_ratio",
          ],
          Where: [
            {
              column: "mid",
              operator: "=",
              value: user_id,
            },
            {
              column: "date(created_at)",
              operator: "=",
              value: dateOnly,
            },
          ],
          GroupBy: ["response"],
          Limit: "10",
          Offset: "0",
        });

        const encrypted = encrypt(requestData);
        const data = await makeAuthenticatedRequest(
          "POST",
          "/fetch",
          { encrypted },
          navigate,
        );

        const decryptdata = decrypt(data);
        const fixedString = decryptdata.replace(/\\"/g, '"');
        const jsonArray = JSON.parse(fixedString);

        dispatch(Todaypayouts(jsonArray)); // Pass the entire response
      } catch (err) {
        setError(err.message);
        AxiosError(navigate, err);
      }
    };
    todatpayout();
    //fundloads();
    //fetchAccountStatus();
  }, [dispatch, user_id, navigate]);

  const success =
    Todaypayoutsdetailes && Todaypayoutsdetailes.length > 0
      ? Todaypayoutsdetailes.filter((item) => item.response === "success")
      : [];

  //console.log("success", success);
  // const pending =
  //   Todaypayoutsdetailes && Todaypayoutsdetailes.length > 0
  //     ? Todaypayoutsdetailes.filter((item) => item.response === "initiated" || item.response === "PROCESSING")
  //     : [];

  const fundLoadHistory =
    fund_history && fund_history.length > 0 ? fund_history : [];

  //const [date, setDate] = useState();

  //console.log("date", Date);
  //console.log("reportDate", user_id);

  const PayoutDownload = async () => {
    try {
      const startDate = reportDate.startDate;
      const endDate = reportDate.endDate;
      const status = reportDate.status;

      let url = `/payouts/by-date/download?fromDate=${startDate}&toDate=${endDate}&mid=${user_id}&type=csv`;

      // ✅ only add status if user selected something (not "all" or empty)
      if (status && status !== "all") {
        url += `&status=${status}`;
      }

      const response = await Report("GET", url, navigate);

      const blob = response.data;

      const text = await blob.text();
      console.log("CSV Content Preview:", text.slice(0, 200)); // Just a preview

      // 🔍 Try to extract filename from headers (if backend sends it)
      const contentDisposition = response.headers["content-disposition"];
      let filename = `payout_report_${startDate}_To_${endDate}_Status_${status}.csv`;

      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+)"?/);
        if (match?.[1]) {
          filename = match[1];
        }
      }

      // 🔻 Start file download
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);

      toast.success("Report downloaded successfully!");
    } catch (err) {
      console.error("Download Error:", err);
      setError(err.message);
      AxiosError(navigate, err);
    }
  };

  const SubmitFundLoad = async () => {
    // Amount Required
    if (!fundLoadForm.amount) {
      toast.error("Amount is required");
      return;
    }

    // Minimum Amount
    if (Number(fundLoadForm.amount) < 100) {
      toast.error("Minimum amount is 100");
      return;
    }

    // Max 7 Digits Amount
    if (fundLoadForm.amount.length > 7) {
      toast.error("Amount should not exceed 7 digits");
      return;
    }

    // Reference Required
    if (!fundLoadForm.refNo.trim()) {
      toast.error("Reference number is required");
      return;
    }

    // Reference Max Length
    if (fundLoadForm.refNo.length > 45) {
      toast.error("Reference number should not exceed 45 characters");
      return;
    }

    // Check Reference Already Exists
    const referenceCheckQuery = JSON.stringify({
      Dname: "payout",
      Tname: "fund_history",
      Cname: ["reference"],
      Where: [
        {
          column: "reference",
          operator: "=",
          value: fundLoadForm.refNo,
        },
      ],
      Limit: "10",
      Offset: "0",
    });

    const encryptedReference = encrypt(referenceCheckQuery);

    const referenceCheckRes = await makeAuthenticatedRequest(
      "POST",
      "/fetch",
      { encrypted: encryptedReference },
      navigate,
    );

    const referenceResult = JSON.parse(
      decrypt(referenceCheckRes).replace(/\\"/g, '"'),
    );

    // Already Exists
    if (referenceResult.length > 1) {
      toast.error("Reference number already submitted");
      return;
    }

    try {
      const updateJson = JSON.stringify({
        Dname: "payout",
        Tname: "fund_history",
        Values: {
          mid: user_id,
          amount: fundLoadForm.amount,
          paymentMode: fundLoadForm.payMode,
          reference: fundLoadForm.refNo,
          remarks: fundLoadForm.remark,
          status: "3",
          type: "1",
        },
      });

      const encrypted = encrypt(updateJson);

      const response = await makeAuthenticatedRequest(
        "POST",
        "/insert",
        { encrypted },
        navigate,
      );

      //console.log("Encrypted Fund Load Response:", response);

      const decryptdata = decrypt(response);

      const jsonArray = JSON.parse(decryptdata.replace(/\\"/g, '"'));
      // const jsonArray = JSON.parse(
      //   decryptdata.replace(/\\"/g, '"')
      // );

      // SUCCESS
      if (jsonArray["Status count"] === "200") {
        toast.success("Fund load request submitted");

        setShowFundModal(false);

        setFundLoadForm({
          depositBank: "",
          amount: "",
          payMode: "IMPS",
          payDate: new Date().toISOString().slice(0, 10),
          refNo: "",
          payslip: null,
          remark: "",
        });

        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
      // DUPLICATE ENTRY
      else if (
        jsonArray["Status_Code"] === "401" &&
        jsonArray.Msg &&
        jsonArray.Msg.includes("Duplicate entry")
      ) {
        toast.error("Reference number already submitted");
      }

      // OTHER ERROR
      else {
        toast.error(jsonArray.Msg || "Request failed");
      }
    } catch (error) {
      const errorMsg = error?.response?.data?.Msg || "";

      if (errorMsg.includes("Duplicate entry")) {
        toast.error("Reference number already submitted");
        return;
      }

      AxiosError(navigate, error);

      toast.error("Something went wrong");

      console.error("Error submitting fund load:", error);
    }
  };

  return (
    <main className="main-content animate-fade-in-up mesh-bg relative overflow-hidden overflow-y-hidden w-[1195px]">
      {/* Decorative Floating Color Orbs */}
      <div className="color-orb-1 top-10 left-10 pointer-events-none" />
      <div className="color-orb-2 bottom-20 right-10 pointer-events-none" />

      {/* Header */}
      <div className="mb-6 flex flex-col md:flex-row md:items-center md:justify-between bg-gradient-to-r from-indigo-900 via-indigo-950 to-slate-950 rounded-3xl px-8 py-6 shadow-xl relative overflow-hidden border border-slate-900 animate-fade-in-up">
        {/* Ambient light leaks inside header */}
        <div className="absolute -top-12 -left-12 w-48 h-48 bg-indigo-500/10 rounded-full blur-3xl pointer-events-none" />
        <div className="absolute -bottom-24 -right-24 w-48 h-48 bg-purple-500/10 rounded-full blur-3xl pointer-events-none" />

        <div className="relative z-10">
          <h2 className="text-3xl font-extrabold text-white tracking-tight flex items-center gap-2">
            <span>Payout Console</span>
            <span
              className={`text-xs px-2.5 py-0.5 rounded-full font-bold uppercase tracking-wider border ${
                profileData.status === "1"
                  ? "bg-indigo-500/25 border-indigo-500/35 text-indigo-300 animate-pulse"
                  : "bg-rose-500/20 border-rose-500/30 text-rose-300"
              }`}
            >
              {profileData.status === "1" ? "Active" : "Inactive"}
            </span>
          </h2>
          <p className="text-indigo-200/80 text-sm mt-1.5 font-medium">
            Execute Payouts, fund your wallet instantly, and manage payout
            records.
          </p>
        </div>
        <nav className="mt-4 md:mt-0 relative z-10">
          <ol className="flex items-center space-x-2 text-xs font-semibold">
            <li>
              <Link
                to="/dashboard"
                className="flex items-center gap-1.5 py-2 px-3 bg-white/5 hover:bg-white/10 rounded-xl text-indigo-200 hover:text-white transition duration-200 border border-white/5"
              >
                <span className="material-icons text-sm">dashboard</span>
                <span>Console</span>
              </Link>
            </li>
            <li className="text-indigo-400">/</li>
            <li className="text-indigo-300/60 font-normal">Payouts</li>
          </ol>
        </nav>
      </div>

      {/* Fund Load Section */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
        {/* Left Card - QR & Wallet Load */}
        {/* <div className="relative glass-panel rounded-3xl border border-slate-100 p-6 overflow-hidden animate-fade-in-up">
          
          <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-indigo-600 to-violet-600"></div>

          <div className="flex flex-col items-center justify-center h-full">
            
            <div className="w-44 h-44 rounded-2xl border-2 border-dashed border-slate-200 flex items-center justify-center bg-slate-50/50 mb-5 relative group">
              <img
                src={QrCode}
                alt="QR Code"
                className="w-40 h-40 object-contain rounded-xl transition duration-300 group-hover:scale-105"
              />
            </div>

            
            <div className="text-center mb-5">
              <p className="text-xs font-bold text-slate-400 uppercase tracking-wider">
                Account Operator
              </p>
              <h3 className="text-xl font-extrabold text-slate-800 mt-1">
                Gaadiaa Technologies LLP
              </h3>
            </div>

           
            <div className="flex flex-col sm:flex-row gap-3 w-full">
              
              <button
                onClick={() => window.open(QrCode, "_blank")}
                className="flex-1 bg-gradient-to-r from-indigo-600 to-violet-600 text-white py-2.5 rounded-xl font-bold shadow-md shadow-indigo-100 hover:shadow-indigo-200 hover:shadow-lg transform hover:-translate-y-0.5 transition duration-150"
              >
                Open QR Code
              </button>

              
              <button
                onClick={() => setShowFundModal(true)}
                className="flex-1 border border-indigo-600 text-indigo-600 py-2.5 rounded-xl font-bold hover:bg-indigo-50/50 transform hover:-translate-y-0.5 transition duration-150"
              >
                Log Fund Load Request
              </button>
            </div>
          </div>
        </div> */}

        {/* Right Card - Fund Load Account Details */}
        <div className="relative glass-panel rounded-3xl border border-slate-100 p-6 overflow-hidden animate-fade-in-up">
          {/* Top Gradient */}
          <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-indigo-600 to-violet-600"></div>

          <div className="flex items-center justify-between mb-5">
            <h3 className="text-lg font-bold text-slate-800">
              Virtual Funding Account
            </h3>

            <div
              className={`inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-bold border ${
                profileData.status === "1"
                  ? "bg-emerald-50 text-emerald-700 border-emerald-100"
                  : "bg-rose-50 text-rose-700 border-rose-100"
              }`}
            >
              <span
                className={`w-1.5 h-1.5 rounded-full mr-1.5 ${profileData.status === "1" ? "bg-emerald-500 animate-pulse" : "bg-rose-500"}`}
              />
              {profileData.status === "1" ? "Active Live" : "Inactive"}
            </div>
          </div>

          <div className="space-y-4">
            {/* Account Number */}
            <div className="bg-slate-50/50 rounded-2xl p-4 border border-slate-100">
              <p className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-1">
                Account Number
              </p>

              <div className="flex items-center justify-between">
                <p className="text-lg font-bold text-slate-800 tracking-wide">
                  {profileData.virtual_account_no}
                </p>

                <button
                  onClick={() => {
                    navigator.clipboard.writeText(
                      profileData.virtual_account_no,
                    );
                    toast.success("Account number copied!");
                  }}
                  className="text-xs font-bold text-indigo-600 hover:text-indigo-800 bg-indigo-50 hover:bg-indigo-100/70 px-2.5 py-1 rounded-lg transition"
                >
                  Copy
                </button>
              </div>
            </div>

            {/* IFSC */}
            <div className="bg-slate-50/50 rounded-2xl p-4 border border-slate-100">
              <p className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-1">
                IFSC Code
              </p>

              <div className="flex items-center justify-between">
                <p className="text-lg font-bold text-slate-800 tracking-wide">
                  {profileData.virtual_account_IFSC}
                </p>

                <button
                  onClick={() => {
                    navigator.clipboard.writeText(
                      profileData.virtual_account_IFSC,
                    );
                    toast.success("IFSC copied!");
                  }}
                  className="text-xs font-bold text-indigo-600 hover:text-indigo-800 bg-indigo-50 hover:bg-indigo-100/70 px-2.5 py-1 rounded-lg transition"
                >
                  Copy
                </button>
              </div>
            </div>

            {/* Info Note */}
            <div className="rounded-2xl bg-indigo-50/40 border border-indigo-100/50 p-4">
              <p className="text-xs font-semibold text-indigo-700 leading-relaxed">
                Add the above account details or use the operator QR pay to load
                your payout balance instantly.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
        {[
          {
            title: "Payout Balance",
            value: `₹ ${profileData.payout_balance}`,
            icon: Wallet,
          },
          {
            title: "Today's Payout",
            value: `₹ ${success?.[0]?.amount || "0.00"}`,
            icon: MessageCircle,
          },
          {
            title: "Today Success Rate",
            value: `${success?.[0]?.success_ratio || "0"} %`,
            icon: FileText,
          },
        ].map((card, idx) => (
          <div
            key={idx}
            className="relative bg-white rounded-2xl p-5 shadow-md border border-gray-200 overflow-hidden"
          >
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-600 to-indigo-600"></div>

            <div className="flex justify-between items-start">
              <div>
                <p className="text-sm text-gray-500">{card.title}</p>
                <h3 className="text-2xl font-bold text-gray-900 mt-2">
                  {card.value}
                </h3>
              </div>
              <card.icon className="w-6 h-6 text-blue-600" />
            </div>
          </div>
        ))}
      </div>

      {/* Table */}
      <div className="mx-auto">
        <div className="rounded-2xl border border-gray-200 bg-white">
          <div className="px-4 sm:px-6 py-4 sm:py-5">
            {/* Search, Status, and Controls Section */}
            <div className="flex flex-col lg:flex-row lg:justify-between gap-4">
              {/* Left Side: Search, Status & Generate Report */}
              <div className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto">
                {/* Search Box */}
                <div className="relative w-full sm:w-64">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <MagnifyingGlassIcon className="h-4 w-4 text-gray-400" />
                  </div>
                  <input
                    type="text"
                    placeholder="Search"
                    className="border border-gray-300 rounded-xl pl-10 pr-3 py-2 text-sm w-full focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    value={searchTerm}
                    onChange={handleSearchChange}
                  />
                </div>

                {/* Status Dropdown */}
                <div className="relative w-full sm:w-48">
                  <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                    <ChevronDownIcon className="h-4 w-4 text-gray-400" />
                  </div>
                  <select
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    className="border border-gray-300 rounded-xl px-3 py-2 text-sm w-full appearance-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="all">All Status</option>
                    <option value="PROCESSING">Initiated</option>
                    <option value="processed">Processed</option>
                    <option value="success">Success</option>
                    <option value="refunded">Refunded</option>
                    <option value="failed">Failed</option>
                  </select>
                </div>

                {/* Generate Report Button */}
                {/* <button
                  onClick={() => setShowReportModal(true)}
                  className="flex items-center justify-center gap-2 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 shadow-sm hover:shadow-md whitespace-nowrap"
                >
                  <DocumentArrowDownIcon className="w-4 h-4" />
                  Generate Report
                </button> */}
                {/* <button
                  onClick={() => setShowReportModal(true)}
                  className="flex items-center justify-center gap-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-4 py-2 rounded-lg text-sm font-medium transition-all duration-500 whitespace-nowrap shadow-md hover:shadow-lg relative overflow-hidden group"
                >
                  <span className="absolute inset-0 bg-gradient-to-r from-blue-500 to-indigo-500 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></span>
                  <DocumentArrowDownIcon className="w-4 h-4 relative z-10 transition-transform group-hover:scale-110" />
                  <span className="relative z-10">Generate Report</span>
                </button> */}
              </div>

              {/* Right Side: Pagination */}
              <div className="w-full lg:w-auto flex justify-center lg:justify-end">
                <div className="inline-flex rounded-md shadow-sm">
                  <button
                    className="inline-flex items-center px-2 sm:px-3 py-1.5 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                    onClick={goToPrevPage}
                    disabled={currentPage === 1}
                  >
                    <ChevronLeftIcon className="h-4 w-4 mr-1" />
                    Prev
                  </button>

                  {/* Always show first page */}
                  <button
                    className={`inline-flex items-center px-3 py-1.5 border-t border-b border-gray-300 text-sm font-medium ${
                      currentPage === 1
                        ? "bg-blue-500 text-white border-blue-500"
                        : "bg-white text-gray-700 hover:bg-gray-50"
                    }`}
                    onClick={() => setCurrentPage(1)}
                  >
                    1
                  </button>

                  {/* Ellipsis */}
                  {currentPage > 3 && (
                    <span className="inline-flex items-center px-2 py-1.5 border-t border-b border-gray-300 bg-white text-sm text-gray-500">
                      <EllipsisHorizontalIcon className="h-4 w-4" />
                    </span>
                  )}

                  {/* Middle Pages */}
                  {[...Array(totalPages)]
                    .map((_, i) => i + 1)
                    .filter(
                      (page) =>
                        page > 1 &&
                        page < totalPages &&
                        Math.abs(page - currentPage) <= 1,
                    )
                    .map((page) => (
                      <button
                        key={page}
                        className={`inline-flex items-center px-3 py-1.5 border-t border-b border-gray-300 text-sm font-medium ${
                          currentPage === page
                            ? "bg-blue-500 text-white border-blue-500"
                            : "bg-white text-gray-700 hover:bg-gray-50"
                        }`}
                        onClick={() => setCurrentPage(page)}
                      >
                        {page}
                      </button>
                    ))}

                  {/* Ellipsis */}
                  {currentPage < totalPages - 2 && (
                    <span className="inline-flex items-center px-2 py-1.5 border-t border-b border-gray-300 bg-white text-sm text-gray-500">
                      <EllipsisHorizontalIcon className="h-4 w-4" />
                    </span>
                  )}

                  {/* Last Page */}
                  {totalPages > 1 && (
                    <button
                      className={`inline-flex items-center px-3 py-1.5 border-t border-b border-gray-300 text-sm font-medium ${
                        currentPage === totalPages
                          ? "bg-blue-500 text-white border-blue-500"
                          : "bg-white text-gray-700 hover:bg-gray-50"
                      }`}
                      onClick={() => setCurrentPage(totalPages)}
                    >
                      {totalPages}
                    </button>
                  )}

                  <button
                    className="inline-flex items-center px-2 sm:px-3 py-1.5 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                    onClick={goToNextPage}
                    disabled={currentPage === totalPages}
                  >
                    Next
                    <ChevronRightIcon className="h-4 w-4 ml-1" />
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Table Section */}
          <div className="p-5 border-t border-gray-100">
            <div className="overflow-hidden rounded-xl border border-gray-200 bg-white">
              <div className="max-w-full overflow-x-auto">
                <table className="min-w-full">
                  <thead>
                    <tr
                      className="text-gray-500 text-xs border-b border-gray-100 bg-gray-50 whitespace-nowrap text-center"
                      style={{ backgroundColor: "#F9FAFB" }}
                    >
                      <th className="px-5 py-3 sm:px-6">SI.No</th>
                      <th className="px-5 py-3 sm:px-6">Created On</th>
                      <th className="px-5 py-3 sm:px-6">UTR</th>
                      <th className="px-5 py-3 sm:px-6">Payout ID</th>
                      <th className="px-5 py-3 sm:px-6">Reference ID</th>
                      <th className="px-5 py-3 sm:px-6">Amount</th>
                      {/* <th className="px-5 py-3 sm:px-6">Open Balance</th>
                      <th className="px-5 py-3 sm:px-6">Close Balance</th> */}
                      <th className="px-5 py-3 sm:px-6">Beneficiary Name</th>
                      <th className="px-5 py-3 sm:px-6">Status</th>
                      <th className="px-5 py-3 sm:px-6">Remarks</th>
                      <th className="px-5 py-3 sm:px-6">Credited On</th>
                      <th className="px-5 py-3 sm:px-6">Request Type</th>
                      <th className="px-5 py-3 sm:px-6">Account Number</th>
                      <th className="px-5 py-3 sm:px-6">Account IFSC</th>
                      <th className="px-5 py-3 sm:px-6">Bank Name</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100">
                    {merchantData.slice(1).length > 0 ? (
                      merchantData.slice(1).map((payout, index) => (
                        <tr
                          key={payout.payout_id}
                          className="whitespace-nowrap text-center"
                        >
                          <td className="px-5 py-3 sm:px-6">
                            <div className="flex items-center">
                              <p className="text-gray-500 text-sm">
                                {index + 1 + (currentPage - 1) * limit}
                              </p>
                            </div>
                          </td>
                          <td className="px-5 py-3 sm:px-6">
                            <div className="flex items-center">
                              <p className="text-gray-500 text-sm">
                                {new Date(payout.created_at).toLocaleString(
                                  "en-IN",
                                  {
                                    day: "2-digit",
                                    month: "short",
                                    year: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  },
                                )}
                              </p>
                            </div>
                          </td>
                          <td className="px-5 py-3 sm:px-6 text-center">
                            <div className="flex items-center justify-center">
                              <p className="text-gray-500 text-sm">
                                {payout.transaction_reference &&
                                payout.transaction_reference !== "null"
                                  ? payout.transaction_reference
                                  : "-"}
                              </p>
                            </div>
                          </td>

                          <td className="px-5 py-3 sm:px-6">
                            <div className="flex items-center">
                              <p className="text-gray-500 text-sm">
                                {payout.payout_id}
                              </p>
                            </div>
                          </td>
                          <td className="px-5 py-3 sm:px-6">
                            <div className="flex items-center">
                              <p className="text-gray-500 text-sm">
                                {payout.reference_id}
                              </p>
                            </div>
                          </td>
                          <td className="px-5 py-3 sm:px-6">
                            <div className="flex items-center">
                              <p className="text-gray-500 text-sm">
                                ₹{payout.amount}
                              </p>
                            </div>
                          </td>
                          {/* <td className="px-5 py-3 sm:px-6">
                            <div className="flex items-center">
                              <p className="text-gray-500 text-sm">
                                ₹{payout.open_balance}
                              </p>
                            </div>
                          </td>
                          <td className="px-5 py-3 sm:px-6">
                            <div className="flex items-center">
                              <p className="text-gray-500 text-sm">
                                ₹{payout.close_balance}
                              </p>
                            </div>
                          </td> */}
                          <td className="px-5 py-3 sm:px-6">
                            <div className="flex items-center">
                              <p className="text-gray-500 text-sm">
                                {payout.beneficiary_name}
                              </p>
                            </div>
                          </td>
                          {/* <!--Status--> */}
                          {/* <td className="px-3 py-1 sm:px-6">
                            <div className="flex items-center">
                              <p
                                className={`
                                          ${payout.response === "success"
                                    ? "bg-green-100 text-green-700"
                                    : payout.response === "failed"
                                      ? "bg-red-100 text-red-700"
                                      : payout.response ===
                                        "sent-for-processing"
                                        ? "bg-yellow-100 text-yellow-700"
                                        : payout.response === "initiated"
                                          ? "bg-yellow-100 text-yellow-700"
                                          : payout.response === "refunded"
                                            ? "bg-purple-50 text-purple-700"
                                            : "bg-gray-100 text-gray-700"
                                  }
                                          text-xs px-3 py-0.5 rounded-full font-semibold
                                        `}
                              >
                                {payout.response}
                              </p>
                            </div>
                          </td> */}

                          <td className="px-3 py-1 sm:px-6 whitespace-nowrap">
                            
                            <div className="flex items-center">
                              <span
                                className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium
                              ${
                                payout.response === "success"
                                  ? "bg-green-50 text-green-700 ring-1 ring-green-200"
                                  : payout.response === "failed"
                                    ? "bg-red-50 text-red-700 ring-1 ring-red-200"
                                    : payout.response === "PROCESSING"
                                      ? "bg-yellow-50 text-yellow-700 ring-1 ring-yellow-200"
                                      : payout.response === "processed"
                                        ? "bg-blue-50 text-blue-700 ring-1 ring-blue-200"
                                        : payout.response === "refunded"
                                          ? "bg-purple-50 text-purple-700 ring-1 ring-purple-200"
                                          : "bg-gray-50 text-gray-700 ring-1 ring-gray-200"
                              }`}
                              >
                                {payout.response === "success" ? (
                                  <CheckCircleIcon className="w-3 h-3 mr-1" />
                                ) : payout.response === "failed" ? (
                                  <XCircleIcon className="w-3 h-3 mr-1" />
                                ) : payout.response ===
                                  "PROCESSING" ? (
                                  <ArrowPathIcon className="w-3 h-3 mr-1 animate-spin" />
                                ) : payout.response === "processed" ? (
                                  <ClockIcon className="w-3 h-3 mr-1" />
                                ) : payout.response === "refunded" ? (
                                  <ArrowUturnLeftIcon className="w-3 h-3 mr-1" />
                                ) : (
                                  <QuestionMarkCircleIcon className="w-3 h-3 mr-1" />
                                )}
                                {payout.response === "PROCESSING"
                                  ? "Initiated"
                                  : payout.response === "processed"
                                    ? "Processed"
                                  : payout.response === "refunded"
                                    ? "Refunded"
                                    : payout.response === "failed"
                                      ? "Failed"
                                      : payout.response === "success"
                                        ? "Success"
                                    : payout.response.charAt(0).toUpperCase() +
                                      payout.response.slice(1)
                                      
                                      }
                              </span>
                            </div>
                          </td>

                          <td className="px-5 py-3 sm:px-6 text-center">
                            <div className="flex items-center justify-center">
                              <p className="text-gray-500 text-sm">
                                {payout.remarks || " - "}
                              </p>
                            </div>
                          </td>
                          <td className="px-5 py-3 sm:px-6 text-center">
                            <div className="flex items-center justify-center">
                              <p className="text-gray-500 text-sm">
                                {payout.credited_at
                                  ? new Date(payout.credited_at).toLocaleString(
                                      "en-IN",
                                      {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                      },
                                    )
                                  : "-"}
                              </p>
                            </div>
                          </td>

                          <td className="px-5 py-3 sm:px-6">
                            <div className="flex items-center">
                              <p className="text-gray-500 text-sm text-center">
                                {payout.requesttype}
                              </p>
                            </div>
                          </td>
                          <td className="px-5 py-3 sm:px-6">
                            <div className="flex items-center">
                              <p className="text-gray-500 text-sm">
                                {payout.account_number}
                              </p>
                            </div>
                          </td>
                          <td className="px-5 py-3 sm:px-6">
                            <div className="flex items-center">
                              <p className="text-gray-500 text-sm">
                                {payout.account_ifsc}
                              </p>
                            </div>
                          </td>
                          <td className="px-5 py-3 sm:px-6">
                            <div className="flex items-center">
                              <p className="text-gray-500 text-sm">
                                {payout.bankname}
                              </p>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="13"
                          className="text-center py-4 text-gray-500"
                        >
                          No payout history found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {showReportModal && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
              <div className="bg-white w-full max-w-md rounded-xl shadow-lg p-6 relative mx-4">
                <button
                  className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
                  onClick={() => setShowReportModal(false)}
                >
                  <X className="w-6 h-6" />
                </button>

                <div className="space-y-1 mb-6">
                  <h2 className="text-2xl font-bold text-gray-900">
                    Generate Report
                  </h2>
                  <p className="text-sm text-gray-500">
                    Select filters to download your report
                  </p>
                </div>

                <div className="space-y-5">
                  {/* From Date */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      From Date
                    </label>
                    <div className="relative">
                      <input
                        type="date"
                        className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        value={reportDate.startDate}
                        onChange={(e) =>
                          setReportDate({
                            ...reportDate,
                            startDate: e.target.value,
                          })
                        }
                        max={new Date().toISOString().slice(0, 10)}
                      />
                      {/* <CalendarIcon className="w-5 h-5 absolute right-3 top-2.5 text-gray-400" /> */}
                    </div>
                  </div>

                  {/* To Date */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      To Date
                    </label>
                    <div className="relative">
                      <input
                        type="date"
                        className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        value={reportDate.endDate}
                        onChange={(e) =>
                          setReportDate({
                            ...reportDate,
                            endDate: e.target.value,
                          })
                        }
                        max={new Date().toISOString().slice(0, 10)}
                      />
                      {/* <CalendarIcon className="w-5 h-5 absolute right-3 top-2.5 text-gray-400" /> */}
                    </div>
                  </div>

                  {/* Status Selection */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Status
                    </label>
                    <div className="relative">
                      <select
                        className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 appearance-none"
                        value={reportDate.status}
                        onChange={(e) =>
                          setReportDate({
                            ...reportDate,
                            status: e.target.value,
                          })
                        }
                      >
                        <option value="" disabled>
                          Select Status
                        </option>
                        <option value="success">Success</option>
                        <option value="failed">Failed</option>
                        <option value="refunded">Refunded</option>
                        <option value="sent-for-processing">
                          Sent for Processing
                        </option>
                      </select>
                      <ChevronDownIcon className="w-5 h-5 absolute right-3 top-2.5 text-gray-400 pointer-events-none" />
                    </div>
                  </div>

                  {/* Download Button */}
                  <button
                    onClick={PayoutDownload}
                    disabled={isGeneratingReport}
                    className={`mt-6 w-full px-4 py-3 rounded-lg font-medium flex items-center justify-center space-x-2 transition-all text-white ${
                      isGeneratingReport
                        ? "bg-blue-400 cursor-not-allowed"
                        : "bg-blue-600 hover:bg-white hover:text-blue-600 hover:border hover:border-blue-600 shadow-md"
                    }`}
                  >
                    {isGeneratingReport ? (
                      <>
                        <ArrowPathIcon className="w-5 h-5 animate-spin" />
                        <span>Generating Report...</span>
                      </>
                    ) : (
                      <>
                        <ArrowDownTrayIcon className="w-5 h-5" />
                        <span>Download Report</span>
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Fund Load Modal */}
          {showFundModal && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
              <div className="bg-white w-full max-w-2xl rounded-2xl shadow-2xl overflow-hidden">
                {/* Header */}
                <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
                  <h2 className="text-xl font-semibold text-gray-900">
                    Load Wallet
                  </h2>

                  <button
                    onClick={() => setShowFundModal(false)}
                    className="text-gray-400 hover:text-gray-600"
                  >
                    <X className="w-6 h-6" />
                  </button>
                </div>

                {/* Body */}
                <div className="p-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                    {/* Deposit Bank */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Deposit Bank
                      </label>

                      <input
                        type="text"
                        disabled
                        placeholder="Enter Deposit Bank"
                        value={profileData.virtual_account_no}
                        onChange={(e) =>
                          setFundLoadForm({
                            ...fundLoadForm,
                            depositBank: e.target.value,
                          })
                        }
                        className="w-full px-4 py-2.5 rounded-xl border text-sm focus:outline-none focus:ring-2 transition border-gray-300 focus:ring-blue-500"
                      />
                    </div>

                    {/* Amount */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Amount
                      </label>

                      <input
                        type="number"
                        placeholder="Enter Amount"
                        value={fundLoadForm.amount}
                        required
                        onChange={(e) =>
                          setFundLoadForm({
                            ...fundLoadForm,
                            amount: e.target.value,
                          })
                        }
                        className="w-full px-4 py-2.5 rounded-xl border text-sm focus:outline-none focus:ring-2 transition border-gray-300 focus:ring-blue-500
  [appearance:textfield]
  [&::-webkit-outer-spin-button]:appearance-none
  [&::-webkit-inner-spin-button]:appearance-none"
                      />
                    </div>

                    {/* Pay Mode */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Pay Mode
                      </label>

                      <div className="relative">
                        <select
                          value={fundLoadForm.payMode}
                          onChange={(e) =>
                            setFundLoadForm({
                              ...fundLoadForm,
                              payMode: e.target.value,
                            })
                          }
                          className="w-full appearance-none px-4 py-2.5 pr-10 rounded-xl border border-gray-300 bg-white text-sm text-gray-700
    outline-none focus:border-blue-500 hover:border-blue-400
    transition-all duration-300 cursor-pointer"
                        >
                          <option value="IMPS">IMPS</option>
                          <option value="NEFT">NEFT</option>
                          <option value="UPI">UPI</option>
                        </select>

                        {/* Dropdown Icon */}
                        <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
                          <ChevronDownIcon className="w-5 h-5 text-gray-400" />
                        </div>
                      </div>
                    </div>

                    {/* Pay Date */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Pay Date
                      </label>

                      <input
                        type="date"
                        value={fundLoadForm.payDate}
                        onChange={(e) =>
                          setFundLoadForm({
                            ...fundLoadForm,
                            payDate: e.target.value,
                          })
                        }
                        className="w-full px-4 py-2.5 rounded-xl border text-sm focus:outline-none focus:ring-2 transition border-gray-300 focus:ring-blue-500"
                      />
                    </div>

                    {/* Ref No */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Ref No
                      </label>

                      <input
                        type="text"
                        placeholder="Enter Reference Number"
                        value={fundLoadForm.refNo}
                        onChange={(e) =>
                          setFundLoadForm({
                            ...fundLoadForm,
                            refNo: e.target.value,
                          })
                        }
                        className="w-full px-4 py-3 rounded-xl border text-sm focus:outline-none focus:ring-2 transition border-gray-300 focus:ring-blue-500"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Payslip (Optional)
                      </label>

                      <label className="w-full flex items-center justify-between px-4 py-3 rounded-xl border border-gray-300 bg-white cursor-pointer hover:border-blue-400 transition-all duration-300">
                        <div className="flex items-center gap-3 overflow-hidden">
                          <ArrowUpTrayIcon className="w-5 h-5 text-blue-500 flex-shrink-0" />

                          <span className="text-sm text-gray-600 truncate">
                            {fundLoadForm.payslip
                              ? fundLoadForm.payslip.name
                              : "Choose Payslip"}
                          </span>
                        </div>

                        <span className="text-xs font-medium text-blue-600">
                          Upload
                        </span>

                        <input
                          type="file"
                          className="hidden"
                          onChange={(e) =>
                            setFundLoadForm({
                              ...fundLoadForm,
                              payslip: e.target.files[0],
                            })
                          }
                        />
                      </label>
                    </div>
                  </div>

                  {/* Remark */}
                  <div className="mt-5">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Remark
                    </label>

                    <textarea
                      rows={2}
                      placeholder="Enter Remark"
                      value={fundLoadForm.remark}
                      onChange={(e) =>
                        setFundLoadForm({
                          ...fundLoadForm,
                          remark: e.target.value,
                        })
                      }
                      className="w-full px-4 py-2 rounded-xl border text-sm focus:outline-none focus:ring-2 transition border-gray-300 focus:ring-blue-500"
                    />
                  </div>

                  {/* Footer Buttons */}
                  <div className="flex items-center justify-end gap-4 mt-8">
                    {/* Cancel Button */}
                    <button
                      onClick={() => setShowFundModal(false)}
                      className="px-6 py-3 rounded-xl border border-gray-300 bg-white text-gray-700 text-sm font-medium
    hover:bg-gray-50 hover:border-gray-400
    active:scale-95 transition-all duration-300"
                    >
                      Cancel
                    </button>

                    {/* Submit Button */}
                    {/* Submit Button */}
                    <button
                      onClick={SubmitFundLoad}
                      className="px-6 py-3 rounded-xl bg-gradient-to-r from-blue-600 to-indigo-600
  text-white text-sm font-semibold shadow-md hover:shadow-xl
  hover:from-blue-700 hover:to-indigo-700
  active:scale-95 transition-all duration-300"
                    >
                      Submit Request
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          <ToastContainer position="top-right" autoClose={3000} />
        </div>
      </div>
    </main>
  );
};

export default Payouts;
